module.exports = __webpack_public_path__ + "static/img/color.d6e1d0d9.svg";